export default "__VITE_ASSET__BE13ZnDc__"